<template>
  <div class="pc-page">
    <div class="test_main test_main_2">
      <Nav></Nav>
      <div class="test_test clearfix">
        <div class="test_test_l">
          <div class="titbox center">
            <h4 class="cn_tit">学习效力</h4>
            <h6 class="en_tit">learning effectiveness</h6>
          </div>
          <div class="desc">
            <p>学习效力指的是如何有效地学习。<br>学习效力主要由方法效力和风格效力组成。其中，方法效力指的是学习策略，风格效力指的是学习风格。</p>
          </div>
          <div class="btngroup test_btngroup">
            <router-link class="btn btn_start" :to="url">开始测评</router-link>
          </div>
        </div>
        <div class="test_test_r">
          <img src="@/assets/newceping/icon_xuexixiaoli.png" alt="" class="img"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Nav from '../../../../components/learningAbility/learningEffectiveness.vue';
  export default{
    data(){
      return {
          url:'/learningAbility/LearningEffectiveness/guide/1'
      }
    },
    components: {Nav},
      created(){
      },
      methods:{
      }
  }
</script>

<style scoped>
  .test_test_r{
    transition: .1s;
  }
</style>
